import { EffectCallback, useEffect } from 'react';

/**
 * A modified version of `useEffect` that only runs one time.
 */
export const useInitialEffect = (callback: EffectCallback): void => {
  // NOTE: In this rare case, disabling exhaustive deps is correct.
  // Based on the rules of `useEffect`, the `callback` arg should never change.
  // Furthermore, this effect should only run _one time_ and ignore any changes
  // to its dependencies.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, []);
};
